<template>
  <div>
      <el-row>
          <el-col :span="24" class="top-title">
              <div>
                  活动中心
              </div>
          </el-col>
          <el-col :span="18" :offset="3" class="examination-box">
              <el-tabs type="border-card" style="min-height:80vh" @tab-click="clickTabChangeFlag">
              <el-tab-pane label="公开活动">
                  <el-row>
                      <div v-if="list.length !== 0">
                          <el-col :span="12" v-for="(item,index) in list" :key="index" >
                              <div class="work-box">
                                  <el-card class="box-card">
                                      <div class="work-title">
                                          {{item.active_name}}
                                      </div>
                                      <el-row>
                                          <el-col :span="6">
                                              <div class="work-img-div">
                                                  <img :src="source_prefix + item.cover_url" style="width:70%" alt="">
                                              </div>
                                          </el-col>
                                          <el-col :span="18" class="work-desc">
                                              <div class="work-start-time">
                                                  开始时间：{{item.active_time[0]}}
                                              </div>
                                              <div class="work-end-time">
                                                  结束时间：{{item.active_time[1]}}
                                              </div>
                                              <div class="work-teacher-name">
                                                  {{item.teacher_name}}
                                              </div>
                                          </el-col>
                                          <el-col :span="24" class="btn-box">
                                            <el-button type="primary" @click="joinActive(item)"  >立即参与</el-button>
                                          <template>
                         
                                          </template>
                                      
                                          </el-col>
                                      </el-row>
                                  </el-card>
                              </div>
                          </el-col>
                      </div>
                      <div v-else>
                          <el-empty description="暂无数据" :image-size="300"></el-empty>
                      </div>
 
                  </el-row>
              </el-tab-pane>
              <el-tab-pane label="校本活动">
                  <el-row>
                      <div v-if="list.length !== 0">
                          <el-col :span="12" v-for="(item,index) in list" :key="index" >
                              <div class="work-box">
                                  <el-card class="box-card">
                                      <div class="work-title">
                                          {{item.work_name}}
                                      </div>
                                      <el-row>
                                          <el-col :span="6">
                                              <div class="work-img-div">
                                                  <img :src="item.cover_url" style="width:70%" alt="">
                                              </div>
                                          </el-col>
                                          <el-col :span="16" class="work-desc">
                                              <div class="work-start-time">
                                                  开始时间：{{item.start_time}}
                                              </div>
                                              <div class="work-end-time">
                                                  结束时间：{{item.end_time}}
                                              </div>
                                              <div class="work-teacher-name">
                                                  {{item.teacher_name}}
                                              </div>
                                          </el-col>
                                          <el-col :span="2">
                                              <template>
                                                  <el-popover
                                                      placement="top-start"
                                                      title=""
                                                      width=""
                                                      trigger="hover"
                                                      content="查看报告。">
                                                      <div class="work-show-btn" @click="showReport(item)" slot="reference">
                                                          <i class="el-icon-s-opportunity"></i>
                                                      </div>
                                                  </el-popover>
                                              </template>
                                      
                                          </el-col>
                                      </el-row>
                                  </el-card>
                              </div>
                          </el-col>
                      </div>
                      <div v-else>
                          <el-empty description="暂无数据" :image-size="300"></el-empty>
                      </div>
      
                  </el-row>
    
              </el-tab-pane>
              </el-tabs>
          </el-col>
      </el-row>
      <Waterfall ref="Waterfall" :dataList = "dataList" :list="list" :form="form"></Waterfall>
  </div>
 
</template>

<script>
  import { activeList} from '@/api'
  import store from '@/store'
  import Waterfall from '@/components/waterfall'
  import { EventBus } from '@/utils/eventbus.js';

  import Vue from 'vue';

  export default {
      name: 'Examination',
      components: {
          Waterfall
      },
      props: ['cate', 'words'],
      data() {
          return {
              source_prefix:process.env.VUE_APP_UPYUN_PATH,
              classPopver:false,
              dialogVisible: false,
              list:[],
              classList:[],
              schoo_code:store.state.user.code,
              listForm:{
                      'page':1,
                      'limit':99,
                      'where':{}
              },
              form:{
                  page: 1,
                  limit: 10,
                  where: {
                    school_code:""
                  }
              },
              defaultLogo:"http://foo.ibianma.com/jingying/word/2022/12/01/d865fb6a3bb7ec265c0942e89337797b.png",
              logoList:{
                  1:"http://foo.ibianma.com/jingying/word/2022/12/01/90473139a17ff1b3657c556f00fc8c9c.png",//答题卡
                  2:"http://foo.ibianma.com/jingying/word/2022/12/01/d865fb6a3bb7ec265c0942e89337797b.png",//题库作业
                  3:"http://foo.ibianma.com/jingying/word/2022/12/01/a44f88abe3be60022b8e9f48d71e11a9.png",//分层
                  5:"http://foo.ibianma.com/jingying/word/2022/12/01/4c8756eb5980d6d7f8e3f7d1b2d5ee47.png",//单词

              },
              activeData:{}
          }
      },
      computed: {
      },
      methods: {
          dataList(clearFlag)
          {
              if(clearFlag === true)
              {
                  this.list = []
                  this.form.page = 1
              }
              activeList(this.form).then(response => {
                  if(response.data.length != 0)
                  {
                      this.list = this.list.concat(response.data)
                      this.$refs.Waterfall.isLoading = false
                  }
   
             
              })
          },
          joinActive(e){
            if(e.category == "CULTURAL_KNOWLEDGE_COMPETITION"){
              this.activeData = e
              store.dispatch('common/setActiveData', e);
              const data = JSON.stringify(e);
              sessionStorage.setItem('activeData', data);
              // 未报名
              if(e.join_status == 0){
                //报名页
                this.$router.push({path:'/signup'})
              }
              //已报名
              if(e.join_status == 1){
                //详情页
                this.$router.push({path:'/active/activeshow'})
              }


            }

          },
          clickTabChangeFlag()
          {
              if(this.form.where.school_code == '')
              {
                  this.form.where.school_code = this.school_code
              }
              else
              {
                  this.form.where.school_code = ''
              }
              this.dataList(true)
          },
          changeFormData(){
              this.dataList(true)
          },
          showReport(e)
          {
              if(e.report_list_flag == 'Y')
              {
                  this.$router.push({path:'/viewreport',query: {work_guid:e.work_guid}})
              }
              else
              {
                  this.$notify.success({
                      title: '信息提示',
                      message: e.report_unavailable_msg,
                      duration: 3000
                  })
              }
          },
          startWork(e)
          {
              this.$router.push({path:'/homeworkanswer',query: {work_guid:e.work_guid}})

          },
 

      },
      mounted() {
          this.dataList()
          

      },
      beforeDestroy () {
        //store.dispatch('common/loadActiveData');
      },
      created(){
        
      }

  }
</script>
<style scoped lang="less">

.btn-box{
    text-align: right;
  }

  .change-class-box{
      text-align: right;
      padding-right: 14%;
  }
  .top-title{
      text-align: center;
      font-size:24px;
      margin-top:1vh;
  }

  .examination-box{
      margin-top:5vh;
  }

  .work-box{
      padding:30px;
  }


  .work-title{
      font-size:24px;
      padding-bottom:10px;
  }

  .work-start-time{
      margin-top:10px;
  }

  .work-end-time{
      margin-top:10px;
  }

  .work-teacher-name{
      margin-top:10px;
  }

  .work-img-div{
      padding:10px;
  }

  .work-show-btn{
      font-size: 28px;
      color: #409EFF;
      cursor: pointer;
      margin-top: 65px;
  }

  .work-desc{
      font-size:18px;
  }

  @media (max-width: 1400px) {
      .work-desc{
          font-size:14px;
      }
  }

</style>
